module.exports = __webpack_public_path__ + "img/honor-9001.02d60e3c.png";